import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronRight, X, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import WaveCanvas from "../WaveCanvas";

const navItems = [
    {
        label: "Who we are",
        link: "/who-we-are",
    },

    {
        label: "What we do",
        link: "/what-we-do",
        showImage: true,
        serviceGroups: [
            {
                title: "Automation & Agentic AI",
                linkss: "/automation-and-ai-agents",
                subtitle: "Agents that deliver outcomes",
                icon: "✧",
                services: [
                    { label: "Conversational AI", link: "automation-and-ai-agents/conversational-ai" },
                    { label: "Machine Learning & ML Ops ", link: "automation-and-ai-agents/machine-learning-mlops" },
                    { label: "Generative AI & LLM", link: "automation-and-ai-agents/generative-ai-llm" },
                    { label: "AI & Automation", link: "automation-and-ai-agents/ai-automation" },
                    { label: "Agentic AI Services", link: "automation-and-ai-agents/agentic-ai-services" },

                ],
            },
            {
                title: "ServiceNow",
                linkss: "/servicenow",

                subtitle: "Workflows that act",
                icon: "♧",
                services: [
                    { label: "ServiceNow Consulting", description: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.", link: "/service/servicenow-consulting" },
                    { label: "ServiceNow Implementation", description: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.", link: "/service/servicenow-implementation" },
                    { label: "ServiceNow ITSM", description: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.", link: "/service/servicenow-itsm" },
                    { label: "ServiceNow ITOM & CMDB", description: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.", link: "/service/servicenow-itom-cmdb" },
                    { label: "ServiceNow CSM", description: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.", link: "/service/servicenow-csm" },
                    { label: "ServiceNow HRSD", description: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.", link: "/service/servicenow-hrsd" },
                    { label: "ServiceNow AI & Automation", description: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.", link: "/service/servicenow-ai-automation" },
                    { label: "ServiceNow Integration", description: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.", link: "/service/servicenow-integration" },
                    { label: "ServiceNow Custom Development", description: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.", link: "/service/servicenow-custom-development" },
                    { label: "ServiceNow Managed Services", description: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.", link: "/service/servicenow-managed-services" },
                    { label: "ServiceNow Resource Augmentation", description: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.", link: "/service/servicenow-resource-augmentation" },
                    { label: "ServiceNow Center of Excellence ", description: "Establish platform standards, governance, reusable practices, and continuous improvement through a dedicated ServiceNow Center of Excellence.", link: "/service/servicenow-coe" },
                ],
            },
            {
                title: "Data Platforms",
                linkss: "/data-ai-databricks-solution",

                subtitle: "Data you can trust · Partner",
                icon: "▱",
                services: [
                    { label: "Databricks Implementation", link: "/data-ai-databricks-solutions/databricks-consulting" },
                    { label: "Lakehouse Architecture & Migration", link: "/data-ai-databricks-solutions/lakehouse-architecture" },
                    { label: "Data Engineering & Governance", link: "/data-ai-databricks-solutions/data-engineering" },
                    { label: "GenAI & Agents on Databricks", link: "/data-ai-databricks-solutions/generative-ai-agent-bricks" },
                    { label: "Analytics, BI & Dashboards", link: "/data-ai-databricks-solutions/databricks-sql-bi" },
                    { label: "Databricks Managed Services", link: "/data-ai-databricks-solutions/databricks-managed-services" },
                ],
            },
            {
                title: "Digital Engineering",
                linkss: "/digital-engineering",

                subtitle: "Allied services to build and run",
                icon: "‹/›",
                services: [
                    //   { label: "Agentic AI Services for Enterprises", link: "/agentic-ai-services" },
                    //   { label: "AI & Automation", link: "/ai-automation" },
                    { label: "Product Engineering", link: "/product-engineering" },
                    { label: "Performance Engineering", link: "/performance-engineering" },
                    { label: "Cloud Engineering", link: "/cloud-engineering" },
                    //   { label: "ServiceNow Consulting", link: "/servicenow-consulting" },
                    //   { label: "Data & Analytics", link: "/data-analytics" },
                    //   { label: "Infor M3 Solutions", link: "/infor-m3-solutions" },
                    //   { label: "Infor EPM Services", link: "/infor-epm-services" },
                    //   { label: "MES Solutions", link: "/manufacturing-execution-system" },
                    { label: "Global Capability Centers", link: "/global-capability-centers" },
                    { label: "Industrial Automation", link: "/industrial-automation" },
                    { label: "Embedded Services", link: "/embedded-services" },
                    { label: "Staff Augmentation", link: "/staff-augmentation" },
                ],
            },
        ],
        children: [
            {
                label: "Agentic AI Services for Enterprises",
                link: "/agentic-ai-services",
            },
            {
                label: "AI & Automation",
                link: "/ai-automation",
            },
            {
                label: "Product Engineering",
                link: "/product-engineering",
            },
            {
                label: "Performance Engineering",
                link: "/performance-engineering",
            },
            {
                label: "Cloud Engineering",
                link: "/cloud-engineering",
            },
            {
                label: "divider",
            },
            {
                label: "ServiceNow Consulting",
                link: "/servicenow-consulting",
            },
            {
                label: "Data & Analytics",
                link: "/data-analytics",
            },
            {
                label: "Infor M3 Solutions",
                link: "/infor-m3-solutions",
            },
            {
                label: "Infor EPM Services",
                link: "/infor-epm-services",
            },
            {
                label: "Global Capability Centers",
                link: "/global-capability-centers",
            },
            {
                label: "divider",
            },
            {
                label: "MES Solutions",
                link: "/manufacturing-execution-system",
            },
            {
                label: "Industrial Automation",
                link: "/industrial-automation",
                subItems: [
                    {
                        label: "Data Extraction & Analytics",
                        link: "/data-extraction-analytics",
                    },
                ],
            },
            {
                label: "Embedded Services",
                link: "/embedded-services",
            },
            {
                label: "Staff Augmentation",
                link: "/staff-augmentation",
            },
        ],
    },

    // {
    //     label: "ServiceNow",
    //     link: "/servicenow",
    //     children: [
    //         {
    //             label: "ServiceNow Consulting",
    //             link: "/service/servicenow-consulting",
    //         },
    //         {
    //             label: "ServiceNow Implementation",
    //             link: "/service/servicenow-implementation",
    //         },
    //         {
    //             label: "ServiceNow ITSM",
    //             link: "/service/servicenow-itsm",
    //         },
    //         {
    //             label: "ServiceNow ITOM & CMDB",
    //             link: "/service/servicenow-itom-cmdb",
    //         },
    //         {
    //             label: "ServiceNow CSM",
    //             link: "/service/servicenow-csm",
    //         },
    //         {
    //             label: "ServiceNow HRSD",
    //             link: "/service/servicenow-hrsd",
    //         },
    //         {
    //             label: "ServiceNow AI & Automation",
    //             link: "/service/servicenow-ai-automation",
    //         },
    //         {
    //             label: "ServiceNow Integration",
    //             link: "/service/servicenow-integration",
    //         },
    //         {
    //             label: "ServiceNow Custom Development",
    //             link: "/service/servicenow-custom-development",
    //         },
    //         {
    //             label: "ServiceNow Managed Services",
    //             link: "/service/servicenow-managed-services",
    //         },
    //         {
    //             label: "ServiceNow Resource Augmentation",
    //             link: "/service/servicenow-resource-augmentation",
    //         },
    //         {
    //             label: "ServiceNow Center of Excellence (COE)",
    //             link: "/service/servicenow-coe",
    //         },
    //     ],
    // },

    {
        label: "Capabilities",
        link: "/capabilities",
        isDarkMegaMenu: true,
        sections: [
            {
                title: "Capabilities",
                col1: [
                    {
                        label: "AI Automation",
                        link: "/capabilities/ai-automation",
                    },
                    {
                        label: "Enterprise Applications",
                        link: "/capabilities/enterprise-applications",
                    },
                    {
                        label: "Digital Workflows",
                        link: "/capabilities/digital-workflows",
                    },
                    {
                        label: "Cloud Engineering",
                        link: "/capabilities/cloud-engineering",
                    },
                    {
                        label: "Industrial Engineering",
                        link: "/capabilities/industrial-engineering",
                    },
                    {
                        label: "Product Engineering",
                        link: "/capabilities/product-engineering",
                    },
                    {
                        label: "Quality Engineering",
                        link: "/capabilities/quality-engineering",
                    },
                    {
                        label: "Managed Services",
                        link: "/capabilities/managed-services",
                    },
                ],
                col2: [],
            },

            {
                title: "Industries",
                col1: [
                    {
                        label: "Retail & E-Commerce",
                        link: "/industries/retail",
                    },
                    {
                        label: "Healthcare & Life Sciences",
                        link: "/industries/healthcare",
                    },
                    {
                        label: "Energy, Oil & Gas",
                        link: "/industries/energy",
                    },
                    {
                        label: "Telecommunications",
                        link: "/industries/telecom",
                    },
                    {
                        label: "Media & Entertainment",
                        link: "/industries/media",
                    },
                    {
                        label: "Transportation & Logistics",
                        link: "/industries/logistics",
                    },
                    {
                        label: "Travel & Hospitality",
                        link: "/industries/travel",
                    },
                    {
                        label: "Government & Public Sector",
                        link: "/industries/government",
                    },
                    {
                        label: "Education (EdTech)",
                        link: "/industries/education",
                    },
                    {
                        label: "Real Estate & Construction",
                        link: "/industries/real-estate",
                    },
                ],
                col2: [
                    {
                        label: "Agriculture & AgriTech",
                        link: "/industries/agriculture",
                    },
                    {
                        label: "Consumer Goods (CPG/FMCG)",
                        link: "/industries/cpg",
                    },
                    {
                        label: "Professional Services",
                        link: "/industries/professional-services",
                    },
                    {
                        label: "Technology & Software",
                        link: "/industries/tech-software",
                    },
                    {
                        label: "Automotive & Mobility",
                        link: "/industries/automotive",
                    },
                    {
                        label: "Aerospace & Defense",
                        link: "/industries/aerospace",
                    },
                    {
                        label: "Utilities",
                        link: "/industries/utilities",
                    },
                    {
                        label: "Non-Profit & NGOs",
                        link: "/industries/non-profit",
                    },
                    {
                        label: "Banking, Financial Services & Insurance",
                        link: "/industries/bfsi",
                    },
                    {
                        label: "Manufacturing & Industrial Automation",
                        link: "/industries/manufacturing",
                    },
                ],
            },
        ],
    },

    {
        label: "Products",
        link: "",
        showImage: true,
        children: [
            {
                label: "Glodesk",
                link: "/glodesk",
                image: "/assets/products/glodesk-thumb.png",
                description:
                    "Transform your IT support with Glodesk, an advanced AI-powered service desk solution for modern enterprises.",
            },
            {
                label: "Glokode",
                link: "/glokode",
                image: "/assets/products/glokode-thumb.png",
                description:
                    "Accelerate your development cycle with Glokode, a revolutionary low-code platform to build apps faster.",
            },
        ],
    },

    {
        label: "Careers",
        link: "/careers",
        isCareerDirectMenu: true,
        children: [
            {
                label: "Working Here",
                link: "/working-here",
            },
            {
                label: "Work-Environment",
                link: "/work-environment",
            },
            {
                label: "About recruiting at Mobikode",
                link: "/recruiting",
            },
            {
                label: "Jobs at Mobikode",
                link: "/all-openings",
            },
        ],
    },

    {
        label: "Contact",
        link: "/contact",
    },
];

function DemoHeader() {
    const [mobileMenu, setMobileMenu] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [activeMobileSub, setActiveMobileSub] = useState(null);
    const [nestedMobileSub, setNestedMobileSub] = useState(null);
    const [scrolled, setScrolled] = useState(false);
    const [hoveredSubItem, setHoveredSubItem] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    // Legal pages do not have the dark hero background used by most pages.
    // Keep the navbar in its light/black-text state on these routes from the first render.
    const normalizedPath = location.pathname.replace(/\/$/, "") || "/";
    const isLegalPage = [
        "/terms-and-conditions",
        "/privacy-policy",
        "/terms",
        "/privacy",
    ].includes(normalizedPath);

    const isNavbarActive = scrolled || openDropdown !== null || isLegalPage;

    useEffect(() => {
        setMobileMenu(false);
        setOpenDropdown(null);
        setActiveMobileSub(null);
        setNestedMobileSub(null);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });

        // Clear the previous page's scroll state when navigating.
        // isLegalPage above independently keeps legal-page navigation styled correctly.
        setScrolled(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        return () =>
            window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setMobileMenu(false);
            }
        };

        window.addEventListener("resize", handleResize);

        return () =>
            window.removeEventListener("resize", handleResize);
    }, []);

    /*
    ============================================================
    MOBILE NAVIGATION LOGIC

    First click:
    - Opens dropdown

    Second click:
    - Navigates to parent page

    This fixes:
    ServiceNow -> dropdown -> ServiceNow page
    What we do -> dropdown -> What we do page
    Capabilities -> dropdown -> Capabilities page
    Careers -> dropdown -> Careers page
    ============================================================
    */

    const handleMobileParentClick = (item) => {
        const hasDropdown = item.children || item.sections;

        if (!hasDropdown) {
            if (item.link) {
                navigate(item.link);
                setMobileMenu(false);
            }

            return;
        }

        // First click -> open dropdown
        if (activeMobileSub !== item.label) {
            setActiveMobileSub(item.label);
            setNestedMobileSub(null);
            return;
        }

        // Second click -> open parent page
        if (item.link) {
            navigate(item.link);
            setMobileMenu(false);
            setActiveMobileSub(null);
            setNestedMobileSub(null);
        }
    };

    /*
    ============================================================
    NESTED MOBILE ITEM

    First click:
    - Open nested submenu

    Second click:
    - Navigate to parent item page
    ============================================================
    */

    const handleNestedMobileClick = (child) => {
        if (!child.subItems) {
            if (child.link) {
                navigate(child.link);
                setMobileMenu(false);
            }

            return;
        }

        if (nestedMobileSub !== child.label) {
            setNestedMobileSub(child.label);
            return;
        }

        if (child.link) {
            navigate(child.link);
            setMobileMenu(false);
            setNestedMobileSub(null);
        }
    };

    return (
        <>
            {/* ============================================================
                DESKTOP / MAIN NAVBAR
            ============================================================ */}

            <div
                className={`fixed top-0 w-full z-50 transition-all duration-500 ease-in-out group
                    ${isNavbarActive
                        ? "py-[10px] bg-white backdrop-blur-md shadow-lg"
                        : "py-[10px] bg-transparent shadow-none"
                    }
                `}
            >
                <div className="mx-auto w-full max-w-[1440px] flex justify-between items-center lg:px-[80px] px-[20px]">

                    {/* LOGO */}

                    <div className="flex items-center cursor-pointer overflow-hidden relative h-[80px] group w-[250px]">

                        <div className="grid grid-cols-1 grid-rows-1 items-center w-full h-full">

                            <Link
                                to="/"
                                className={`col-start-1 row-start-1 z-10 block w-auto transition-all duration-500 ease-in-out ${!isNavbarActive
                                    ? "opacity-0 -translate-y-full"
                                    : "opacity-100 translate-y-0 group-hover:opacity-0 group-hover:-translate-y-full"
                                    }`}
                            >
                                <img
                                    src="/assets/nav/logo.svg"
                                    alt="icon"
                                    style={{ maxHeight: "40px" }}
                                />
                            </Link>

                            <Link
                                to="/"
                                className={`col-start-1 row-start-1 z-20 block w-auto transition-all duration-500 ease-in-out ${!isNavbarActive
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-full group-hover:opacity-100 group-hover:translate-y-0"
                                    }`}
                            >
                                <img
                                    src="/assets/nav/newlogo.png"
                                    className={`w-auto transition-all duration-300 lg:max-h-[40px] max-h-[33px] ${!isNavbarActive
                                        ? "brightness-0 invert"
                                        : "brightness-0"
                                        }`}
                                    alt="logo"
                                />
                            </Link>

                        </div>
                    </div>


                    {/* DESKTOP MENU */}

                    <div className="hidden lg:flex items-center gap-6">

                        <ul className="flex font-sora space-x-2 gap-[20px] text-lg font-medium relative">

                            {navItems.map((item, index) => (

                                <li
                                    key={index}
                                    className="relative"
                                    onMouseEnter={() =>
                                        (item.children || item.sections) &&
                                        setOpenDropdown(index)
                                    }
                                    onMouseLeave={() =>
                                        (item.children || item.sections) &&
                                        setOpenDropdown(null)
                                    }
                                >

                                    <Link
                                        to={item.link}
                                        className={`relative inline-flex items-center font-geist gap-1 py-[26px] text-[16px] font-[600] cursor-pointer group/menuitem transition-colors duration-300 ${isNavbarActive
                                            ? "text-black"
                                            : "text-white"
                                            }`}
                                    >

                                        <span className="relative">

                                            {item.label}

                                            <span
                                                className={`absolute left-0 bottom-[-8px] h-[2px] transition-all duration-300 ${isNavbarActive
                                                    ? "bg-black"
                                                    : "bg-white"
                                                    } ${openDropdown === index
                                                        ? "w-full"
                                                        : "w-0 group-hover/menuitem:w-full"
                                                    }`}
                                            />

                                        </span>

                                        {(item.children || item.sections) && (
                                            <svg
                                                className={`w-5 h-5 ml-1 transition-transform duration-200 ${openDropdown === index
                                                    ? "rotate-180"
                                                    : "rotate-0"
                                                    }`}
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M6 9l6 6 6-6" />
                                            </svg>
                                        )}

                                    </Link>


                                    {/* DESKTOP DROPDOWN */}

                                    <AnimatePresence>

                                        {(item.children || item.sections) &&
                                            openDropdown === index && (

                                                <motion.div
                                                    initial={{
                                                        opacity: 0,
                                                        y: -10,
                                                    }}
                                                    animate={{
                                                        opacity: 1,
                                                        y: 0,
                                                    }}
                                                    exit={{
                                                        opacity: 0,
                                                        y: -10,
                                                    }}
                                                    transition={{
                                                        duration: 0.3,
                                                        ease: "easeInOut",
                                                    }}
                                                    className={`${item.label ===
                                                        "Who we are"
                                                        ? "absolute top-[80px] left-1/2 -translate-x-1/2 w-[220px]"
                                                        : "fixed top-[80px] left-0 w-full"
                                                        } z-50`}
                                                >

                                                    {item.isDarkMegaMenu ? (
                                                        <div className="bg-white relative w-full shadow-lg border-t border-gray-100">
                                                            <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] py-5 sm:py-6">
                                                         <div className="grid grid-cols-1 xl:grid-cols-[30%_70%] gap-1 items-stretch">
                                                                {item.sections.map((section, sectionIndex) => (
    <section
        key={section.title}
        className={`min-w-0 bg-gradient-to-b from-[#F2F4FF] to-[#E7EDFF] px-5 py-5 sm:px-6 sm:py-6 lg:px-7 ${
            sectionIndex === 0 ? "" : ""
        }`}
    >
        <h3 className="font-sora text-[19px] sm:text-[21px] font-bold leading-[1.3] tracking-[-0.02em] text-[#073B70]">
            {section.title}
        </h3>

        <div className="mb-5 mt-4 h-px w-full bg-[#D3D9E7]" />

        {sectionIndex === 0 ? (
            // CAPABILITIES - SINGLE COLUMN
            <div className="flex flex-col gap-[18px]">
                {section.col1.map((link) => (
                    <Link
                        key={link.label}
                        to={link.link}
                        onClick={() => setOpenDropdown(null)}
                        className="block text-[13px] sm:text-[14px] leading-[1.4] font-medium text-[#68758B] transition-colors duration-200 hover:text-[#E96700]"
                    >
                        {link.label}
                    </Link>
                ))}
            </div>
        ) : (
            // INDUSTRIES - THREE COLUMNS
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-[18px]">
                {[...section.col1, ...section.col2].map((link) => (
                    <Link
                        key={link.label}
                        to={link.link}
                        onClick={() => setOpenDropdown(null)}
                        className="block text-[13px] sm:text-[14px] leading-[1.4] font-medium text-[#68758B] transition-colors duration-200 hover:text-[#E96700]"
                    >
                        {link.label}
                    </Link>
                ))}
            </div>
        )}
    </section>
))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (

                                                        <div className="bg-white shadow-lg w-full flex flex-wrap border-t border-gray-100">

                                                            <div
                                                                className={`${item.label === "Who we are"
                                                                    ? "p-2"
                                                                    : item.label === "What we do"
                                                                        ? "w-full p-0 flex flex-col"
                                                                        : "max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] flex items-start justify-between gap-[50px] pt-[26px] pb-[50px]"
                                                                    }`}
                                                            >

                                                                <div className="flex-grow">

                                                                    {item.label === "What we do" ? (
                                                                        <div className="w-full">
                                                                            <div className="mx-auto flex min-h-[62px] w-full max-w-[1440px] lg:px-[80px] px-[20px] items-center justify-between gap-4 bg-white text-left">
                                                                                <h6 className="m-0 font-sora text-[18px] sm:text-[20px] font-bold tracking-tight text-[#073B70]">What we Do</h6>
                                                                                <Link
                                                                                    to="/what-we-do"
                                                                                    onClick={() => setOpenDropdown(null)}
                                                                                    className="inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] sm:text-[14px] font-semibold text-[#E96700] transition-colors hover:text-[#B94D00]"
                                                                                >
                                                                                    All Services <ChevronRight size={16} />
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    ) : item.label !== "Who we are" && (
                                                                        <h6 className="text-[24px] font-sora font-[600] text-[#01386A] pb-[25px] text-left">
                                                                            {item.label}
                                                                        </h6>
                                                                    )}


                                                                    {/* PRODUCTS */}

                                                                    {item.label === "What we do" ? (
                                                                        <div className="mx-auto relative grid w-full max-w-[1440px] grid-cols-1 items-stretch gap-[4px] bg-white text-left sm:grid-cols-2 xl:grid-cols-4 lg:px-[80px] px-[20px] pb-[50px]">
                                                                            {item.serviceGroups.map((group, index) => (
                                                                                <section
                                                                                    key={group.title}
                                                                                    className="relative min-w-0 bg-gradient-to-b from-[#F3F5FF] to-[#E5ECFF] py-5 sm:px-5 lg:px-6 lg:py-5 overflow-hidden"
                                                                                >
                                                                                    <div className="relative z-10">
                                                                                        <a href={group.linkss} onClick={() => setOpenDropdown(null)} className="inline-flex items-center gap-2">
                                                                                            <h3 className="font-sora text-[17px] sm:text-[18px] leading-[1.3] font-bold tracking-[-0.02em] text-[#073B70]">
                                                                                                {group.title}
                                                                                            </h3>
                                                                                        </a>
                                                                                        <p className="mt-1.5 text-[12px] leading-[18px] font-normal text-[#68758B]">
                                                                                            {group.subtitle}
                                                                                        </p>
                                                                                        <div className="mb-5 mt-4 h-px w-full max-w-[260px] bg-[#D3D9E7]" />
                                                                                        <div className="flex flex-col gap-[16px]">
                                                                                            {group.services.map((service) => (
                                                                                                <Link
                                                                                                    key={service.label}
                                                                                                    to={service.link}
                                                                                                    onClick={() => setOpenDropdown(null)}
                                                                                                    className="block text-[13px] sm:text-[14px] leading-[1.35] font-medium text-[#68758B] transition-colors duration-200 hover:text-[#E96700]"
                                                                                                >
                                                                                                    {service.label.trim()}
                                                                                                </Link>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* {(index === 0) && (
                                                                                        <div className="absolute inset-0 z-0 opacity-80 pointer-events-none">
                                                                                            <FlowingMeshCanvasAlt />
                                                                                        </div>
                                                                                    )}
                                                                                    {(index === 2) && (
                                                                                        <div className="absolute inset-0 z-0 opacity-80 pointer-events-none">
                                                                                            <FlowingMeshCanvasBox3 />
                                                                                        </div>
                                                                                    )} */}
                                                                                </section>
                                                                            ))}
                                                                        </div>
                                                                    ) : item.label ===
                                                                        "Products" ? (
                                                                        <div className="mx-auto grid w-[calc(100%)] max-w-[1440px] grid-cols-1 items-stretch gap-[4px] bg-white text-left sm:grid-cols-2">
                                                                            {item.children.map((child, i) => (
                                                                                <section
                                                                                    key={i}
                                                                                    className="min-w-0 bg-gradient-to-b from-[#F2F4FF] to-[#E7EDFF] px-5 py-5 sm:px-6 sm:py-6 lg:px-7"
                                                                                >
                                                                                    <Link
                                                                                        to={child.link}
                                                                                        onClick={() => setOpenDropdown(null)}
                                                                                        className="inline-flex items-center gap-2"
                                                                                    >
                                                                                        <h3 className="font-sora text-[17px] sm:text-[18px] leading-[1.3] font-bold tracking-[-0.02em] text-[#073B70] transition-colors duration-200 hover:text-[#E96700]">
                                                                                            {child.label}
                                                                                        </h3>
                                                                                    </Link>
                                                                                    <p className="mt-2 text-[12px] sm:text-[13px] leading-[1.6] font-normal text-[#68758B]">
                                                                                        {child.description}
                                                                                    </p>
                                                                                    <div className="mb-5 mt-4 h-px w-full max-w-[260px] bg-[#D3D9E7]" />
                                                                                    <Link
                                                                                        to={child.link}
                                                                                        onClick={() => setOpenDropdown(null)}
                                                                                        className="inline-flex items-center gap-1 text-[13px] sm:text-[14px] leading-[1.35] font-medium text-[#68758B] transition-colors duration-200 hover:text-[#E96700]"
                                                                                    >
                                                                                        Learn More
                                                                                        <ChevronRight size={15} />
                                                                                    </Link>
                                                                                </section>
                                                                            ))}
                                                                        </div>

                                                                    ) : item.isCareerDirectMenu ? (

                                                                        <div className="grid grid-cols-4 gap-y-6 w-full text-left items-stretch">

                                                                            {item.children.map(
                                                                                (
                                                                                    child,
                                                                                    i
                                                                                ) => (

                                                                                    <div
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                        className="flex flex-col justify-start border-l border-[#6C76894A] pl-[25px] py-1"
                                                                                    >

                                                                                        <Link
                                                                                            to={
                                                                                                child.link
                                                                                            }
                                                                                            onClick={() =>
                                                                                                setOpenDropdown(
                                                                                                    null
                                                                                                )
                                                                                            }
                                                                                            className="font-sora text-[15px] font-[600] text-[#6C7689] hover:text-[#01386A] transition-colors leading-normal"
                                                                                        >
                                                                                            {
                                                                                                child.label
                                                                                            }
                                                                                        </Link>

                                                                                    </div>

                                                                                )
                                                                            )}

                                                                        </div>

                                                                    ) : item.label ===
                                                                        "ServiceNow" ? (

                                                                        <div className="grid grid-cols-3 pl-[20px] border-l border-[#6C76894A] w-full gap-x-[30px] text-left">

                                                                            <div className="flex flex-col gap-y-[20px]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        0,
                                                                                        4
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) => (

                                                                                            <Link
                                                                                                key={
                                                                                                    i
                                                                                                }
                                                                                                to={
                                                                                                    child.link
                                                                                                }
                                                                                                onClick={() =>
                                                                                                    setOpenDropdown(
                                                                                                        null
                                                                                                    )
                                                                                                }
                                                                                                className="block whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black"
                                                                                            >
                                                                                                {
                                                                                                    child.label
                                                                                                }
                                                                                            </Link>

                                                                                        )
                                                                                    )}

                                                                            </div>


                                                                            <div className="flex flex-col gap-y-[20px] pl-[20px] border-l border-[#6C76894A]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        4,
                                                                                        8
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) => (

                                                                                            <Link
                                                                                                key={
                                                                                                    i
                                                                                                }
                                                                                                to={
                                                                                                    child.link
                                                                                                }
                                                                                                onClick={() =>
                                                                                                    setOpenDropdown(
                                                                                                        null
                                                                                                    )
                                                                                                }
                                                                                                className="block whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black"
                                                                                            >
                                                                                                {
                                                                                                    child.label
                                                                                                }
                                                                                            </Link>

                                                                                        )
                                                                                    )}

                                                                            </div>


                                                                            <div className="flex flex-col gap-y-[20px] pl-[20px] border-l border-[#6C76894A]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        8,
                                                                                        12
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) => (

                                                                                            <Link
                                                                                                key={
                                                                                                    i
                                                                                                }
                                                                                                to={
                                                                                                    child.link
                                                                                                }
                                                                                                onClick={() =>
                                                                                                    setOpenDropdown(
                                                                                                        null
                                                                                                    )
                                                                                                }
                                                                                                className="block whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black"
                                                                                            >
                                                                                                {
                                                                                                    child.label
                                                                                                }
                                                                                            </Link>

                                                                                        )
                                                                                    )}

                                                                            </div>

                                                                        </div>

                                                                    ) : (

                                                                        <div className="grid grid-cols-3 pl-[20px] border-l border-[#6C76894A] w-full gap-x-[30px] text-left">

                                                                            <div className="flex flex-col gap-y-[20px]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        0,
                                                                                        5
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) =>
                                                                                            child.label ===
                                                                                                "divider" ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <Link
                                                                                                    key={
                                                                                                        i
                                                                                                    }
                                                                                                    to={
                                                                                                        child.link
                                                                                                    }
                                                                                                    onClick={() =>
                                                                                                        setOpenDropdown(
                                                                                                            null
                                                                                                        )
                                                                                                    }
                                                                                                    className="block whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black"
                                                                                                >
                                                                                                    {
                                                                                                        child.label
                                                                                                    }
                                                                                                </Link>
                                                                                            )
                                                                                    )}

                                                                            </div>


                                                                            <div className="flex flex-col gap-y-[20px] pl-[20px] border-l border-[#6C76894A]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        5,
                                                                                        11
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) =>
                                                                                            child.label ===
                                                                                                "divider" ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <Link
                                                                                                    key={
                                                                                                        i
                                                                                                    }
                                                                                                    to={
                                                                                                        child.link
                                                                                                    }
                                                                                                    onClick={() =>
                                                                                                        setOpenDropdown(
                                                                                                            null
                                                                                                        )
                                                                                                    }
                                                                                                    className="block whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black"
                                                                                                >
                                                                                                    {
                                                                                                        child.label
                                                                                                    }
                                                                                                </Link>
                                                                                            )
                                                                                    )}

                                                                            </div>


                                                                            <div className="flex flex-col gap-y-[20px] pl-[20px] border-l border-[#6C76894A]">

                                                                                {item.children
                                                                                    .slice(
                                                                                        11,
                                                                                        17
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            child,
                                                                                            i
                                                                                        ) =>
                                                                                            child.label ===
                                                                                                "divider" ? (
                                                                                                ""
                                                                                            ) : (
                                                                                                <div
                                                                                                    key={
                                                                                                        i
                                                                                                    }
                                                                                                    className="relative flex flex-col items-start w-full"
                                                                                                    onMouseEnter={() =>
                                                                                                        child.subItems &&
                                                                                                        setHoveredSubItem(
                                                                                                            true
                                                                                                        )
                                                                                                    }
                                                                                                    onMouseLeave={() =>
                                                                                                        child.subItems &&
                                                                                                        setHoveredSubItem(
                                                                                                            false
                                                                                                        )
                                                                                                    }
                                                                                                >

                                                                                                    <div className="inline-flex items-center gap-2 whitespace-nowrap font-geist font-[600] text-[14px] text-[#6C7689] hover:text-black w-full justify-between pr-4 cursor-pointer">

                                                                                                        <Link
                                                                                                            to={
                                                                                                                child.link
                                                                                                            }
                                                                                                            onClick={() =>
                                                                                                                setOpenDropdown(
                                                                                                                    null
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            {
                                                                                                                child.label
                                                                                                            }
                                                                                                        </Link>

                                                                                                        {child.subItems && (
                                                                                                            <ChevronDown
                                                                                                                size={
                                                                                                                    14
                                                                                                                }
                                                                                                                className={`transition-transform duration-300 ${hoveredSubItem
                                                                                                                    ? "rotate-180"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                            />
                                                                                                        )}

                                                                                                    </div>


                                                                                                    <AnimatePresence>

                                                                                                        {child.subItems &&
                                                                                                            hoveredSubItem && (

                                                                                                                <motion.div
                                                                                                                    initial={{
                                                                                                                        opacity: 0,
                                                                                                                        height: 0,
                                                                                                                        marginTop: 0,
                                                                                                                    }}
                                                                                                                    animate={{
                                                                                                                        opacity: 1,
                                                                                                                        height: "56px",
                                                                                                                        marginTop: 8,
                                                                                                                    }}
                                                                                                                    exit={{
                                                                                                                        opacity: 0,
                                                                                                                        height: 0,
                                                                                                                        marginTop: 0,
                                                                                                                    }}
                                                                                                                    transition={{
                                                                                                                        duration: 0.3,
                                                                                                                        ease: "easeInOut",
                                                                                                                    }}
                                                                                                                    className="flex flex-col w-full bg-[#01386A] p-2 gap-1 overflow-hidden"
                                                                                                                >

                                                                                                                    {child.subItems.map(
                                                                                                                        (
                                                                                                                            sub,
                                                                                                                            subIdx
                                                                                                                        ) => (

                                                                                                                            <Link
                                                                                                                                key={
                                                                                                                                    subIdx
                                                                                                                                }
                                                                                                                                to={
                                                                                                                                    sub.link
                                                                                                                                }
                                                                                                                                className="px-3 py-1.5 text-[13px] font-[600] text-[#FFFFFF] transition-colors block text-left"
                                                                                                                                onClick={() =>
                                                                                                                                    setOpenDropdown(
                                                                                                                                        null
                                                                                                                                    )
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    sub.label
                                                                                                                                }
                                                                                                                            </Link>

                                                                                                                        )
                                                                                                                    )}

                                                                                                                </motion.div>

                                                                                                            )}

                                                                                                    </AnimatePresence>

                                                                                                </div>
                                                                                            )
                                                                                    )}

                                                                            </div>

                                                                        </div>

                                                                    )}

                                                                </div>


                                                                {/* WHAT WE DO IMAGE */}

                                                                {item.label ===
                                                                    "What we do" && false && (
                                                                        <div className="max-w-[396px] w-full hidden md:block">

                                                                            <div className="h-[265px] w-full overflow-hidden shadow-md rounded-sm">

                                                                                <img
                                                                                    src="/assets/what/navbar-img.png"
                                                                                    className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                                                                                    alt="navigation visuals"
                                                                                />

                                                                            </div>

                                                                        </div>
                                                                    )}


                                                                {/* SERVICENOW IMAGE */}

                                                                {item.label ===
                                                                    "ServiceNow" && (
                                                                        <div className="max-w-[396px] w-full hidden md:block">

                                                                            <div className="h-[265px] w-full overflow-hidden shadow-md rounded-sm">

                                                                                <img
                                                                                    src="/assets/what/item3.png"
                                                                                    className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                                                                                    alt="navigation visuals"
                                                                                />

                                                                            </div>

                                                                        </div>
                                                                    )}

                                                            </div>

                                                        </div>

                                                    )}

                                                </motion.div>

                                            )}

                                    </AnimatePresence>

                                </li>

                            ))}

                        </ul>

                    </div>


                    {/* MOBILE MENU BUTTON */}

                    <button
                        className="lg:hidden flex flex-col gap-1.5 p-2"
                        onClick={() => setMobileMenu(true)}
                    >
                        <span
                            className={`w-6 h-0.5 transition-colors ${isNavbarActive ? "bg-black" : "bg-white"
                                }`}
                        />

                        <span
                            className={`w-6 h-0.5 transition-colors ${isNavbarActive ? "bg-black" : "bg-white"
                                }`}
                        />

                        <span
                            className={`w-4 h-0.5 transition-colors self-end ${isNavbarActive ? "bg-black" : "bg-white"
                                }`}
                        />
                    </button>

                </div>
            </div>


            {/* ============================================================
                MOBILE OVERLAY
            ============================================================ */}

            {mobileMenu && (
                <div
                    className="fixed inset-0 bg-black/50 z-[99998] lg:hidden"
                    onClick={() => setMobileMenu(false)}
                />
            )}


            {/* ============================================================
                MOBILE SIDE MENU
            ============================================================ */}

            <div
                className={`fixed top-0 right-0 h-full w-[85%] max-w-[400px] z-[99999] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out overflow-y-auto lg:hidden ${mobileMenu
                    ? "translate-x-0"
                    : "translate-x-full"
                    }`}
            >

                <div className="p-6">

                    {/* MOBILE HEADER */}

                    <div className="flex justify-between items-center mb-10">

                        <img
                            src="/assets/nav/newlogo.png"
                            className="h-[30px] brightness-0"
                            alt="logo"
                        />

                        <button
                            onClick={() => setMobileMenu(false)}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        >
                            <X
                                size={28}
                                className="text-black"
                            />
                        </button>

                    </div>


                    {/* MOBILE NAV */}

                    <nav className="flex flex-col gap-2">

                        {navItems.map((item, idx) => (

                            <div
                                key={idx}
                                className="border-b border-gray-100 last:border-0"
                            >

                                {(item.children || item.sections) ? (

                                    <>
                                        {/* 
                                        ==================================================
                                        IMPORTANT:
                                        First click = dropdown
                                        Second click = parent page
                                        ==================================================
                                        */}

                                        <button
                                            onClick={() =>
                                                handleMobileParentClick(item)
                                            }
                                            className="flex justify-between items-center w-full py-4 text-[18px] font-semibold text-[#01386A] text-left"
                                        >

                                            {item.label}

                                            <ChevronDown
                                                size={20}
                                                className={`transition-transform duration-300 ${activeMobileSub ===
                                                    item.label
                                                    ? "rotate-180"
                                                    : ""
                                                    }`}
                                            />

                                        </button>


                                        {/* DROPDOWN CONTENT */}

                                        <div
                                            className={`overflow-hidden transition-all duration-300 ${activeMobileSub === item.label
                                                ? "max-h-[3000px] pb-4"
                                                : "max-h-0"
                                                }`}
                                        >

                                            <div className="flex flex-col gap-3 pl-4 border-l-2 border-gray-100 text-left">

                                                {/* DARK MEGA MENU */}

                                                {item.label === "What we do" ? (
                                                    item.serviceGroups.map((group) => (
                                                        <div key={group.title} className="py-2">
                                                            <div className="font-bold text-[15px] text-[#12395B]">{group.title}</div>
                                                            <div className="mt-2 flex flex-col gap-2 pl-3 border-l border-gray-200">
                                                                {group.services.map((service) => (
                                                                    <div key={service.label}>
                                                                        <Link to={service.link} className="block py-1 text-[14px] font-medium text-gray-700 hover:text-[#D8752A]" onClick={() => setMobileMenu(false)}>{service.label}</Link>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : item.isDarkMegaMenu ? (

                                                    item.sections.map(
                                                        (sec, secIdx) => (

                                                            <React.Fragment
                                                                key={secIdx}
                                                            >

                                                                <div className="text-[#01386A] font-bold text-[14px] mt-2 mb-1">
                                                                    {
                                                                        sec.title
                                                                    }
                                                                </div>

                                                                {[
                                                                    ...sec.col1,
                                                                    ...sec.col2,
                                                                ].map(
                                                                    (
                                                                        child,
                                                                        cIdx
                                                                    ) => (

                                                                        <Link
                                                                            key={
                                                                                cIdx
                                                                            }
                                                                            to={
                                                                                child.link
                                                                            }
                                                                            className="text-[15px] text-gray-600 hover:text-[#01386A] py-1 pl-2"
                                                                            onClick={() =>
                                                                                setMobileMenu(
                                                                                    false
                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                child.label
                                                                            }
                                                                        </Link>

                                                                    )
                                                                )}

                                                            </React.Fragment>

                                                        )
                                                    )

                                                ) : (

                                                    /* NORMAL CHILDREN */

                                                    item.children.map(
                                                        (
                                                            child,
                                                            cIdx
                                                        ) => (

                                                            child.label ===
                                                                "divider" ? (

                                                                <div
                                                                    key={cIdx}
                                                                    className="my-2 border-t border-gray-50"
                                                                />

                                                            ) : (

                                                                <div
                                                                    key={cIdx}
                                                                >

                                                                    <div
                                                                        className="flex justify-between items-center py-1 cursor-pointer"
                                                                        onClick={() =>
                                                                            handleNestedMobileClick(
                                                                                child
                                                                            )
                                                                        }
                                                                    >

                                                                        <span className="text-[15px] text-gray-600 hover:text-[#01386A]">
                                                                            {
                                                                                child.label
                                                                            }
                                                                        </span>

                                                                        {child.subItems && (
                                                                            <ChevronDown
                                                                                size={
                                                                                    16
                                                                                }
                                                                                className={`transition-transform duration-300 ${nestedMobileSub ===
                                                                                    child.label
                                                                                    ? "rotate-180"
                                                                                    : ""
                                                                                    }`}
                                                                            />
                                                                        )}

                                                                    </div>


                                                                    {/* NESTED SUBMENU */}

                                                                    {child.subItems &&
                                                                        nestedMobileSub ===
                                                                        child.label && (

                                                                            <div className="bg-[#F4F7FF] ml-2 mt-1 rounded-md p-2 flex flex-col gap-2">

                                                                                {child.subItems.map(
                                                                                    (
                                                                                        sub,
                                                                                        sIdx
                                                                                    ) => (

                                                                                        <Link
                                                                                            key={
                                                                                                sIdx
                                                                                            }
                                                                                            to={
                                                                                                sub.link
                                                                                            }
                                                                                            className="text-[14px] text-[#01386A] py-1 pl-2 border-l border-blue-200"
                                                                                            onClick={() =>
                                                                                                setMobileMenu(
                                                                                                    false
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                sub.label
                                                                                            }
                                                                                        </Link>

                                                                                    )
                                                                                )}

                                                                            </div>

                                                                        )}

                                                                </div>

                                                            )
                                                        )
                                                    )

                                                )}

                                            </div>

                                        </div>

                                    </>

                                ) : (

                                    /* NORMAL MOBILE LINK */

                                    <Link
                                        to={item.link}
                                        onClick={() =>
                                            setMobileMenu(false)
                                        }
                                        className="block py-4 text-[18px] font-semibold text-[#01386A] text-left"
                                    >
                                        {item.label}
                                    </Link>

                                )}

                            </div>

                        ))}

                    </nav>


                    {/* GET STARTED */}

                    <div className="mt-10">

                        <Link
                            to="/contact"
                            onClick={() =>
                                setMobileMenu(false)
                            }
                            className="block w-full text-center bg-[#0E2A62] text-white py-4 rounded-lg font-bold hover:bg-[#01386A] transition-colors"
                        >
                            Get Started
                        </Link>

                    </div>

                </div>

            </div>
        </>
    );
}

export default DemoHeader;






const FlowingMeshCanvasAlt = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            if (!canvas) return;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width || canvas.offsetWidth || window.innerWidth;
            canvas.height = rect.height || canvas.offsetHeight || 300;
        };

        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        const draw = () => {
            const { width, height } = canvas;
            ctx.clearRect(0, 0, width, height);

            const lines = 24;
            const midY = height * 0.5;
            const speed = 0.0035;

            ctx.lineWidth = 1;

            for (let i = 0; i < lines; i++) {
                ctx.beginPath();

                const t = i / (lines - 1);
                const alpha = 0.12 + Math.sin(t * Math.PI) * 0.28;
                ctx.strokeStyle = `rgba(1, 56, 106, ${alpha})`;

                const offsetSpread = (t - 0.5) * (height * 0.32);

                for (let x = 0; x <= width; x += 10) {
                    const normX = x / width;

                    const primaryWave =
                        Math.sin(normX * Math.PI * 2.3 - time + t * 0.7) * (height * 0.28);

                    const secondaryWave =
                        Math.cos(normX * Math.PI * 3.4 + time * 0.6 - t * 0.5) * (height * 0.12);

                    const pinch = Math.sin(normX * Math.PI);
                    const y = midY + (primaryWave + secondaryWave + offsetSpread * pinch);

                    if (x === 0) {
                        ctx.moveTo(x, y);
                    } else {
                        ctx.lineTo(x, y);
                    }
                }
                ctx.stroke();
            }

            time += speed;
            animationFrameId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            window.removeEventListener("resize", resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return <canvas ref={canvasRef} className="w-full h-full block" />;
};

const FlowingMeshCanvasBox3 = () => {
    const canvasRef = useRef(null);

   useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            if (!canvas) return;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width || canvas.offsetWidth || window.innerWidth;
            canvas.height = rect.height || canvas.offsetHeight || 300;
        };

        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();

        const draw = () => {
            const { width, height } = canvas;
            ctx.clearRect(0, 0, width, height);

            const lines = 24;
            const midY = height * 0.5;
            const speed = 0.0035;

            ctx.lineWidth = 1;

            for (let i = 0; i < lines; i++) {
                ctx.beginPath();

                const t = i / (lines - 1);
                const alpha = 0.12 + Math.sin(t * Math.PI) * 0.28;
                ctx.strokeStyle = `rgba(1, 56, 106, ${alpha})`;

                const offsetSpread = (t - 0.5) * (height * 0.32);

                for (let x = 0; x <= width; x += 10) {
                    const normX = x / width;

                    const primaryWave =
                        Math.sin(normX * Math.PI * 2.3 - time + t * 0.7) * (height * 0.28);

                    const secondaryWave =
                        Math.cos(normX * Math.PI * 3.4 + time * 0.6 - t * 0.5) * (height * 0.12);

                    const pinch = Math.sin(normX * Math.PI);
                    const y = midY + (primaryWave + secondaryWave + offsetSpread * pinch);

                    if (x === 0) {
                        ctx.moveTo(x, y);
                    } else {
                        ctx.lineTo(x, y);
                    }
                }
                ctx.stroke();
            }

            time += speed;
            animationFrameId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            window.removeEventListener("resize", resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return <canvas ref={canvasRef} className="w-full rotate-[90deg] h-full block" />;
};